import { useDashboardAudience } from './dashboardAudience'
import { useSearchParams } from 'react-router-dom'
import type { PortalActivityListKind } from './portalActivityLists.types'

export function portalActivityListParams(
  source: URLSearchParams,
  kind: PortalActivityListKind,
  csv = false,
) {
  const params = new URLSearchParams()
  if (source.get('q')) params.set('q', source.get('q')!)
  const defaultSort = kind === 'courses' ? 'completed:desc' : 'person:asc'
  const sorts =
    kind === 'courses'
      ? ['completed:desc', 'completed:asc', 'person:asc', 'person:desc']
      : ['person:asc', 'person:desc']
  const sort = source.get('sort') ?? defaultSort
  params.set('sort', sorts.includes(sort) ? sort : defaultSort)
  const filter = kind === 'courses' ? 'status' : 'level'
  const values = (source.get(filter) ?? '')
    .split(',')
    .filter(
      (value) => value && (filter === 'level' || ['completed', 'in_progress'].includes(value)),
    )
  if (values.length) params.set(filter, [...new Set(values)].join(','))
  if (!csv && source.get('cursor')) params.set('cursor', source.get('cursor')!)
  return params
}
export function usePortalActivityListState(organizationId: number, kind: PortalActivityListKind) {
  const [source, setSource] = useSearchParams()
  const params = portalActivityListParams(source, kind)
  const base = `${useDashboardAudience(organizationId).base}/${kind}`
  const change = (key: string, value: string) => {
    const next = new URLSearchParams(source)
    next.delete('cursor')
    if (value) next.set(key, value)
    else next.delete(key)
    setSource(next)
  }
  const clear = () => {
    const next = new URLSearchParams(source)
    for (const key of ['q', 'status', 'level', 'cursor']) next.delete(key)
    setSource(next)
  }
  return {
    params,
    change,
    clear,
    path: `${base}?${params}`,
    csvPath: `${base}.csv?${portalActivityListParams(source, kind, true)}`,
  }
}
